import {observer} from "mobx-react";
import {Fragment} from "react";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import FontBody4 from "../../../../components/fonts/font-body4/font-body4";
import {FONT_COLOR, FONT_VARIANT} from "../../../../components/fonts/font-props";
import Hr from "../../../../components/hr/hr";
import {BUTTON_VARIANTS} from "../../../../components/inputs/button-variants";
import {Button} from "../../../../components/inputs/button/button";
import {RadioButton} from "../../../../components/inputs/radio-button/radio-button";
import MediaWithPlaceholder, {MEDIA_VARIANTS} from "../../../../components/media-with-placeholder/media-with-placeholder";
import PlatformProductSearchStore from "../../stores/platform-product-search-store";
import PlatformProductStore from "../../stores/platform-product-store";
import './product-option.scss';

interface IProductOptionProps {
    product: PlatformProductStore;
    productSearchStore: PlatformProductSearchStore;
}

const ProductOption: React.FC<IProductOptionProps> = observer(({product, productSearchStore}) => {
    let variantContainer = null;
    if (product.noVariants) {
        variantContainer = <Hr/>
    }
    else {
        variantContainer = (
            <div className={'product-option-variant-container'}>
                <div>
                    <FontBody2 color={FONT_COLOR.PRIMARY2}>__NA__ Variants</FontBody2>
                    <Button variant={BUTTON_VARIANTS.Transparent}
                            text={'Load variants'}
                            isLoading={product.isLoading}
                            hasLoader={true}
                            onClick={product.loadVariants}/>
                </div>
                <div className={'product-option-variant-list'}>
                    {product.variants.map(variant => {
                        return (
                            <Fragment key={variant.id}>
                                <RadioButton name={''}
                                     value={variant.id}
                                     checked={productSearchStore.selectedProductVariant === variant}
                                     onChange={() => productSearchStore.selectProductVariant(product, variant)}/>
                    
                                <FontBody4 color={FONT_COLOR.PRIMARY2}>{variant.title}</FontBody4>
                                <FontBody4 color={FONT_COLOR.PRIMARY2}>Available Quantity:{variant.quantity}</FontBody4>
                                <div className={'product-option-variant-justify-end'}>
                                    <FontBody4 color={FONT_COLOR.PRIMARY2}>Price:__NA__{variant.price}</FontBody4>
                                </div>
                            </Fragment>
                        );
                    })}
                </div>
            </div>
        );
    }
    
    return (
        <div className={'product-option'}>
            <div className={'product-option-header'}>
                <div className={'product-radio'}>
                    {product.noVariants && <RadioButton name={''} value={product.id} checked={productSearchStore.selectedProduct === product} onChange={() => productSearchStore.selectProduct(product)}  />}
                </div>
                <MediaWithPlaceholder variant={MEDIA_VARIANTS.SMALL} src={product.imageSrc} alt={product.title}/>
                <div className={'product-option-text'}>
                    <FontBody1 color={FONT_COLOR.PRIMARY2}>{product.title}</FontBody1>
                    { product.noVariants &&
                      <>
                          <div>
                              <FontBody4 color={FONT_COLOR.PRIMARY2}>Available Quantity: _NA_</FontBody4>
                          </div>
                          <div className={'product-price'}>
                              <FontBody4 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>Price: _NA_</FontBody4>
                          </div>
                      </>
                    }
                </div>
            </div>
            {variantContainer}
        </div>
    );
});

export default ProductOption;